import { render, staticRenderFns } from "./OrderMovementsHistory.vue?vue&type=template&id=2c94ef17"
import script from "./OrderMovementsHistory.vue?vue&type=script&lang=js"
export * from "./OrderMovementsHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderMovementsHistory.vue?vue&type=style&index=0&id=2c94ef17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports